import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { UPLOAD_TO_SERVER_LIST } from 'src/constants/queryKeys';

export const networkCreateUploadToServer = async (data) => {
  const res = await axiosInstance.post('UploadToServer/Insert', data);
  return res;
};

export const networkGetUploadToServerInfo = async (uploadToServerId) => {
  const res = await axiosInstance.post(`UploadToServer/Info/${uploadToServerId}`);
  return res;
};

export const networkUpdateUploadToServer = async (id, data) => {
  const res = await axiosInstance.post(`UploadToServer/Update/${id}`, data);
  return res;
};

export const networkGetUploadToServerList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`UploadToServer/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchUploadToServerList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [UPLOAD_TO_SERVER_LIST, payload, pageIndex],
    queryFn: () => networkGetUploadToServerList(payload, pageIndex, pageSize),
  });
}

export const networkGetUploadToServerStatusList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`UploadToServerStatus/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchUploadToServerStatusList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['upload-to-server-status-list', pageIndex],
    queryFn: () => networkGetUploadToServerStatusList(pageIndex, pageSize),
  });
}

export const networkGetUploadToServerTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`UploadToServerType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchUploadToServerTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['upload-to-server-type-list', pageIndex],
    queryFn: () => networkGetUploadToServerTypeList(pageIndex, pageSize),
  });
}

export const networkGetUploadToServerLinkToMedia = async (data) => {
  const res = await axiosInstance.post('UploadToServerResult/LinkToMedia', data);
  return res;
};

export const networkGetUploadToServerBasePath = async () => {
  const res = await axiosInstance.get('UploadToServer/BasePath');
  return res;
};
